// A short-lived session for Telegram's embedded panel. Web login keeps its cookie.
const CONTEXT = 'fishit_miniapp_launch';
const TOKEN = 'fishit_miniapp_session';
const USER = 'fishit_user';
let fallback = {};

const read = (key) => { try { return sessionStorage.getItem(key) || fallback[key]; } catch { return fallback[key]; } };
const write = (key, value) => { fallback[key] = value; try { sessionStorage.setItem(key, value); } catch {} };
const remove = (key) => { delete fallback[key]; try { sessionStorage.removeItem(key); } catch {} };
const actorOf = (raw) => { try { return JSON.parse(new URLSearchParams(raw).get('user')).id; } catch { return null; } };
const embedded = () => { try { return window.self !== window.top; } catch { return true; } };

export function captureMiniappLaunch() {
  if (!embedded()) return;
  const raw = new URLSearchParams(window.location.hash.slice(1)).get('tgWebAppData');
  if (raw) {
    const old = read(CONTEXT);
    if (old && actorOf(old) !== actorOf(raw)) clearMiniappSession();
    write(CONTEXT, raw);
  }
}
captureMiniappLaunch(); // Before /auth/me can redirect to /login and remove the hash.

export const isMiniapp = () => embedded() && Boolean(read(CONTEXT));
export const miniappLaunch = () => isMiniapp() ? read(CONTEXT) : '';

export function clearMiniappSession() { remove(TOKEN); remove(USER); }
export function saveMiniappSession(data) {
  if (!isMiniapp() || !data.access_token || !Number.isFinite(Date.parse(data.expires_at))) {
    throw new Error('Sesi Mini App belum tersedia');
  }
  write(TOKEN, JSON.stringify({token:data.access_token, expires:Date.parse(data.expires_at)}));
}
export function miniappToken() {
  if (!isMiniapp()) return null;
  try {
    const saved = JSON.parse(read(TOKEN) || 'null');
    if (saved && saved.expires > Date.now()) return saved.token;
  } catch {}
  clearMiniappSession();
  return null;
}

export function readAuthUser() {
  try { return JSON.parse((isMiniapp() ? read(USER) : localStorage.getItem(USER)) || 'null'); } catch { return null; }
}
export function saveAuthUser(user) {
  if (isMiniapp()) write(USER,JSON.stringify(user));
  else localStorage.setItem(USER,JSON.stringify(user));
}
export function clearAuthUser() {
  if (isMiniapp()) clearMiniappSession();
  else localStorage.removeItem(USER);
}
